import PersonBasicInfoHeader from './PersonBasicInfoHeader';

export default PersonBasicInfoHeader;
